import { useState } from 'react';
import { INft } from '@kattana-io/common';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import Loader from '../../components/common/Loader';

import './styles.scss';

interface INftIconProps {
  nft: INft;
  selected?: string;
  onSelect(icon?: string): void;
}

const NftIcon = ({ nft, selected, onSelect }: INftIconProps) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const image_url = nft.nft_data?.[0]?.external_data?.image;

  if (!image_url || error) {
    return (
      <div className='nft_placeholder'>
        <Text
          size={12}
          className='nft_placeholder__text'
          style={{ title: nft.contract_name }}
        >
          {nft.contract_name}
        </Text>
      </div>
    );
  }
  return (
    <div
      className={`nft_icon ${
        selected === image_url ? 'nft_icon--selected' : ''
      }`}
    >
      {loading && <Loader />}
      <Image
        size='sub_avatar'
        onClick={() => onSelect(selected === image_url ? undefined : image_url)}
        src={image_url}
        onError={() => setError(true)}
        onLoad={() => setLoading(false)}
        className={loading ? 'nft_icon--loading' : ''}
      />
    </div>
  );
};

export default NftIcon;
